<template>
  <v-container>
    <h2
      class="hidden-lg-and-up mx-5 mb-5 font-weight-light"
      style="color: #333"
    >{{ this.$route.name }}</h2>

    <v-row class="ma-2">
      <v-col v-for="attendance in attendance" :key="`${attendance.period}`" cols="12" md="4">
        <AttendanceGraph :attendance="attendance" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import attendance from "@/data/bsd/attendance.json";
import AttendanceGraph from "@/components/core/AttendanceGraph";

export default {
  name: "BSD",
  components: { AttendanceGraph },
  data() {
    return {
      attendance: attendance
    };
  }
};
</script>

<style>
.Area-Name {
  color: #333;
}
</style>